/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 26.05.17.
 */

import React from "react";
import PropTypes from "prop-types";

import {NotificationActions} from "../../services/Notification";
import BaseDynamicContainer from "../../containers/BaseDynamicContainer";
import ForgotPasswordModal from "./ForgotPasswordModal";
import {t} from "../../trans";

class ForgotPasswordContainer extends BaseDynamicContainer {
    static propTypes = {
        resetCode: PropTypes.bool,
        email: PropTypes.string,
        readOnly: PropTypes.bool,
        /**
         * onClose(roleSelected);
         */
        onClose: PropTypes.func.isRequired
    };

    static defaultProps = {
        resetCode: false
    };

    constructor(props) {
        super(props, {
            forgot: "forgotPassword"
        });
        this.state.email = props.email;

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    /**
     *
     */
    loadingFinished(key, newState) {
        if (key === "forgot") {
            NotificationActions.success.defer(t("E-mail sent"));
            this.props.onClose(true);
        }
    }

    onSubmit() {
        this.actions("forgot").post({email: this.state.email, resetCode: this.props.resetCode});
    }

    /**
     *
     * @param field Changed field: "activeRole" or "isDefault"
     * @param value
     */
    onChange(field, value) {
        this.setState({[field]: value});
    }

    render() {
        return (
            <ForgotPasswordModal
                onChange={this.onChange}
                onClose={this.props.onClose}
                onSubmit={this.onSubmit}
                email={this.state.email}
                readOnly={this.props.readOnly}
                resetCode={this.props.resetCode}
            />
        );
    }
}

export default ForgotPasswordContainer;
